import { render, staticRenderFns } from "./PlantImageUploadItemForm.vue?vue&type=template&id=47a9ca82&scoped=true"
import script from "./PlantImageUploadItemForm.vue?vue&type=script&lang=ts"
export * from "./PlantImageUploadItemForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a9ca82",
  null
  
)

export default component.exports